import { create } from "zustand";

export const useLoadingStore = create<any>()((set) => ({
  isLoading: false,
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  tip: '読み込み中...',
  setTip: (tip: string) => set({ tip }),
  // 'default' = 通常スピナー / 'analyzing' = 解析中の専用アニメ
  variant: 'default',
  setVariant: (variant: 'default' | 'analyzing') => set({ variant })
}));
